@for (item of (subSociety() | slice:0:1); track $index) {
<div class="rts-feature-area rts-section-gap">
    <div class="container-fluid padding-controler plr--120">
        <div class="row bg-white-feature pt--120 pb--120">
            <div class="col-xl-2 col-lg-10">
                <div class="feature-left-area">
                    <img *ngIf="item?.image?.path" [src]="item.image.path | imageUrl" [alt]="item.image.originalName">
                </div>
            </div>
            <div class="col-xl-8 col-lg-10">
                <div class="rts-title-area feature text-end pr--30 pr_sm--0">
                    <p class="pre-title">
                        {{ item.title }}
                    </p>
                    <div [innerHTML]="item.description | safeHtml"></div>
                    <h2 class="title feature-title">{{ item.summary }}</h2>
                </div>
                @if(item?.subSocietyItems?.length!>0){
                <div class="feature-one-wrapper pl--30 mt--40 pl_sm--0 ">
                    @for (feature of item.subSocietyItems | slice:0:4; track $index) {
                    <a [routerLink]="['/sub-specialized-society-details',feature.id]" class="single-feature-one">
                        <i class="fal fa-check"></i>
                        <p>{{ feature.name }}</p>
                    </a>
                    }
                </div>
                }
                <div class="my-5">
                    <a class="rts-btn btn-primary color-h-black" [routerLink]="'/branch'">{{"COMMON.MORE
                        THAN"|translate}}
                    </a>
                </div>
            </div>

            <div class="col-xl-2 col-lg-2 aboutus-home-ad-space">

                @for (item of Announcements(); track $index) {
                @if (!item.isDefault) {
                <a target="_blank" [href]="item?.url" class="col-md-4 home-ad-space">
                    <app-ads [imageSrc]="item?.image?.path | imageUrl" [altText]="item?.name" [showSpacing]=false
                        ngClass="v-ad-space">
                    </app-ads>
                </a>
                }
                @else {
                <app-ads imageSrc="/images/ad/350.350.png" [showSpacing]=false ngClass="v-ad-space"></app-ads>
                }
                }
            </div>

        </div>
    </div>
</div>
}